import { render, staticRenderFns } from "./AutoCallTaskDetail.vue?vue&type=template&id=48b9537a&scoped=true&"
import script from "./AutoCallTaskDetail.vue?vue&type=script&lang=js&"
export * from "./AutoCallTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "./AutoCallTaskDetail.vue?vue&type=style&index=0&id=48b9537a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9537a",
  null
  
)

export default component.exports